import React, { FC } from 'react';
import styles from './styles.module.scss';
import { t } from '../../../i18n';

interface IProps {
  title: string;
  value: string;
  icon: string;
  href?: string;
}

const VacancyContact: FC<IProps> = ({ title, value, icon, href }) => (
  <div className={styles.contacts__column}>
    <div className={styles.contacts__icon}>
      <img src={icon} alt={title} />
    </div>

    <div className={styles.contacts__text}>
      <div className={styles.contacts__label}>{t(title)}</div>
      <div className={styles.contacts__value}>
        {href ? (
          <a href={href} rel="nofollow noreferrer" target="_blank">
            {value}
          </a>
        ) : (
          value
        )}
      </div>
    </div>
  </div>
);

export { VacancyContact };
